export const PAGE_SIZE = 200;

export interface SliceInfo {
  startIndex: number;
  stopIndex: number;
}
